// Loads /data/property_listings.json (produced by pipeline/property/...).
// Stub-data today; will swap for the live adapter output without UI changes.
import { useQuery } from '@tanstack/react-query';

export interface Listing {
  source: string;
  country: string;
  external_id: string;
  url: string;
  deal: 'sale' | 'rent';
  price_eur: number;
  currency: string;
  lat: number;
  lon: number;
  area_m2: number | null;
  rooms: number | null;
  locality_raw: string;
  locality_istat: string | null;
  title: string | null;
}

interface ListingsFile {
  _meta: { generated: string; source: string; schema_version: number; note?: string };
  listings: Listing[];
}

export function usePropertyListings() {
  return useQuery({
    queryKey: ['property-listings'],
    queryFn: async (): Promise<ListingsFile> => {
      const res = await fetch('/data/property_listings.json');
      if (!res.ok) throw new Error(`property_listings.json: ${res.status}`);
      return res.json();
    },
    staleTime: 6 * 60 * 60 * 1000, // 6h — pipeline runs daily
    gcTime: Number.POSITIVE_INFINITY,
  });
}
